/**
 * Para onde voltar depois do login. Quem abre um link do portal (o do book de fotos num e-mail, por exemplo) sem estar logado cai na
 * tela de login e, entrando, volta para a página que pediu em vez de ir para o início. Guardado na aba (sessionStorage) e só caminhos
 * do próprio portal: nada que leve para outro site.
 */
const CHAVE = 'np-retorno'

/** Só caminhos internos do portal (/app/...), sem barra dupla nem endereço de fora. */
export function caminhoSeguro(caminho: string | null | undefined): string | null {
  if (!caminho || caminho.length > 300) return null
  if (!caminho.startsWith('/app/')) return null
  if (caminho.includes('//') || caminho.includes('\\') || /[\u0000-\u001f]/.test(caminho)) return null
  return caminho
}

export function guardarRetorno(caminho: string): void {
  const seguro = caminhoSeguro(caminho)
  if (!seguro) return
  try {
    sessionStorage.setItem(CHAVE, seguro)
  } catch {
    // Sem armazenamento (janela privada, bloqueio): o login segue para o início, como antes.
  }
}

/** O caminho guardado, uma vez só: depois de lido, some. */
export function lerRetorno(): string | null {
  try {
    const guardado = sessionStorage.getItem(CHAVE)
    sessionStorage.removeItem(CHAVE)
    return caminhoSeguro(guardado)
  } catch {
    return null
  }
}
